
// jQuery.noConflict();

jQuery(function($){

    $('.load-more-btn').on('click', function(){

        let $button = $(this),
            $postGrid = $button.siblings('.post-grid'),
            lms = $button.attr("data-lms"),
            target = $button.attr('data-target'),
            instance = $button.attr('data-instance');

        let localizationObjectKey = 'load_more_params_';

        if (instance) {
            localizationObjectKey = 'load_more_params_' + instance;
        }

        let pageNumber = window[localizationObjectKey].current_page;



        if (target && target !== 'undefined') {
            $postGrid = $('#'+target);
        }

        if ($postGrid.attr('data-paged')) {
            pageNumber = $postGrid.attr('data-paged');
        }



        let data = {
            'action': 'loadmore',
            'query': window[localizationObjectKey].posts,
            'page' : pageNumber
        };
        $.ajax({
            url : window[localizationObjectKey].ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            beforeSend : function () {
                $button.text(window[localizationObjectKey].localization.loading);
            },
            success : function( response ){

                let parsedResponse = JSON.parse(response);

                $postGrid.attr("data-paged",  parsedResponse['current_page']);

                if( parsedResponse.data ) {

                    $button.text( lms );
                    let $content = $(parsedResponse.data);
                    if ($postGrid.hasClass('masonry')) {
                        $postGrid.append($content).masonry('appended', $content);
                    } else {
                        $postGrid.append(parsedResponse.data);
                    }



                    if (parsedResponse['current_page'] >= window[localizationObjectKey].max_page) {
                        $button.hide(); // if last page, remove the button
                    }

                } else {
                    $button.hide(); // if no data, remove the button as well
                }
            }
        });
    });
});
